import { render, staticRenderFns } from "./alarmData.vue?vue&type=template&id=4bba70b2&scoped=true"
import script from "./alarmData.vue?vue&type=script&lang=js"
export * from "./alarmData.vue?vue&type=script&lang=js"
import style0 from "./alarmData.vue?vue&type=style&index=0&id=4bba70b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bba70b2",
  null
  
)

export default component.exports